<script setup lang="ts">
    import PlannerSidebarRail from './PlannerSidebarRail.vue';
    import PlannerSidebarContent from './PlannerSidebarContent.vue';
    import { usePlannerSidebarViewModel } from './usePlannerSidebarViewModel';

    const vm = usePlannerSidebarViewModel();
</script>

<template>
    <planner-sidebar-rail />
    <planner-sidebar-content v-if="vm.showContent" />
</template>
